import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import LegalPage from "@/pages/LegalPage";
import DeleteAccount from "@/pages/DeleteAccount";
import AdminApp from "@/pages/admin/AdminApp";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/privacy-policy" element={<LegalPage pageKey="privacy_policy" fallbackTitle="Privacy Policy" />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        <Route path="/delete-data" element={<LegalPage pageKey="delete_data" fallbackTitle="Delete Your Data" />} />
        <Route path="/admin" element={<AdminApp />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
